import * as Common from '../../common/common'
import * as Servlet from '../../common/servlet'
import axios from "axios";

/***************************************************/
/************** DOM 로드 후 초기화 함수 호출 *************/
/***************************************************/
let wpArray = [];

window.addEventListener('DOMContentLoaded', (event) => {
	const rmststs = Servlet.lsttm() // 현재 시간 이전 시간 값 가져옴 
	rmststs.then((result) => {
		document.getElementById('lsttm').value = result[0].lsttm

		// 날짜 세팅
		Common.set1DayTime2sc()

		// 달력 표출
		//Common.setDatePicker('scSDate', 'scSImg')
		//Common.setDatePicker('scEDate', 'scEImg')

		const getHour = result[0].lsttm.substring(8, 10)
		const getMin = result[0].lsttm.substring(10, 12)

		Common.selectMakeHour('scSHour', getHour)
		Common.selectMakeMin('scSMin', getMin)
		Common.selectMakeHour('scEHour', getHour)
		Common.selectMakeMin('scEMin', getMin)

		let limit = sessionStorage.getItem("MSG.search.period.limit.year");
		let searchWord = limit.replace("<N>", "1");
		let searchLimit = document.getElementById("searchLimit");
		searchLimit.innerText = "· " + searchWord;

		/*const getHour = result[0].lsttm.substring(8, 10)
		const getMin = result[0].lsttm.substring(10, 12)

		Common.setDatePicker('searchDate', 'img')	// 달력 표출
		Common.selectMakeHour('searchHour', getHour)
		Common.selectMakeMin('searchMin', getMin)

		document.getElementById("searchDate").value = result[0].format.substring(0, 10)*/

	}).then(() => {
		warningData("all");
	})

	/*const downloadBtn = document.getElementById('downloadBtn')
	downloadBtn.addEventListener('click', function() {
		window.location.href = '/page/download/download.html?type=wp'
	})*/
});

/**
 * 경보 목록 호출
 */
const warningData = function(wpStatus) {
	showLoading();

	let wpFilteredData = [];
	let wpParam = makeMstParam();

	Common.axios.all([
		Common.axiosApi.post(`/warning/getAllInfoList`), // 경보 관측소 정보
		Common.axiosApi.post(`/warning/Mst/${wpParam.ymdhm.edt}`), // 현재 경보
		Common.axiosApi.post(`/warning/Acc/Between/${wpParam.ymdhm.sdt}/${wpParam.ymdhm.edt}`),
		Common.axiosApi.post(`/waterlevel/WlIfList/all/all`), // 수위 관측소 정보
		Common.axiosApi.post(`/waterlevel/Mst/${wpParam.ymdhm.edt}`), // 현재 수위
	]).then(Common.axios.spread((wpinfo, wpmst, wpacc, wlinfo, wlmst) => {
		wpFilteredData = wpinfo.filter(el => el.usecd === "1001" && el.hpdspcd === "1001");
		wpFilteredData.forEach((info, i) => {
			const wpdata = wpinfo.find(el => el.wpobscd === info.wpobscd);
			const accdata = wpacc != null ? wpacc.find(element => element.wpobscd === info.wpobscd) : null;
			const mstdata = wpmst != null ? wpmst.find(element => element.wpobscd === info.wpobscd) : null;
			const grpWlobs = info.wlobscd != null || info.wlobscd.trim() !== "" ? info.wlobscd : null;
			const wlobscd_ = grpWlobs != null ? grpWlobs : info.wpobscd.substring(0, 5) + '6' + info.wpobscd.substring(6, 9); // 경보관측소 코드르 수위 관측소 코드로 변환
			const wldata = wlinfo ? wlinfo.find(el => el.wlobscd === wlobscd_) : null;
			const wlmstdata = wlmst ? wlmst.find(el => el.wlobscd === wlobscd_) : null;

			info.obsnm = wpdata.obsnm;
			if (accdata != undefined) { // 발령 났을때만 데이터 출력
				info.wrnstepcd = accdata.wrnstepcd;

				info.wlobsnm = wldata.obsnm;
				info.wl = wlmstdata ? wlmstdata.wl : '-';
				info.wrnstep1 = wldata ? wldata.wrnstep1 : '-';
				info.wrnstep2 = wldata ? wldata.wrnstep2 : '-';
				info.wrnstep3 = wldata ? wldata.wrnstep3 : '-';

				info.wlymdhm = Common.getDateTime2Separator(wpParam.ymdhm.edt, '-');
				info.ymdhm = Common.getDateTime2Separator(accdata.issdt, '-');
			} else { // 발령 없으면 "-" 처리
				info.ymdhm = "-";
				info.wlobsnm = "-";
				info.wlymdhm = "-";
				info.wl = "-";
			}
		});

		wpStatus = document.getElementById("wpStatus").value;
		if (wpStatus == "all") {
			getWarningList(wpFilteredData);
		} else {
			wpFilteredData = wpFilteredData.filter(el => el.wrnstepcd === wpStatus);
			getWarningList(wpFilteredData);
		}
	})).catch((err) => {
		console.log(err);
	}).finally(() => {
		hideLoading();
	});
}

// 테이블 생성
function getWarningList(result) {
	const warningTbody = document.querySelector('#wpTable tbody');
	let wpTableHtml = '';

	// 이름순 정렬을 위한 배열에 값 넣기
	wpArray = result;

	// 이름순으로 정렬
	wpArray.sort(function(a, b) {
		if (a.wpobscd.toLowerCase() < b.wpobscd.toLowerCase()) return -1;
		if (a.wpobscd.toLowerCase() > b.wpobscd.toLowerCase()) return 1;
		return 0;
	});

	//정렬순으로 목록 표출
	wpArray.forEach(info => {
		let status, wl, wrnstep1, wrnstep2, wrnstep3;

		if (info.wrnstepcd === '3301') {
			//status = sessionStorage.getItem("TABLE.alert");
			status = "Alert";
		} else if (info.wrnstepcd === '3302') {
			//status = sessionStorage.getItem("TABLE.alarm");
			status = "Warning"
		} else if (info.wrnstepcd === '3303') {
			//status = sessionStorage.getItem("TABLE.critical");
			status = "Critical";
		} else if (info.wrnstepcd === '3304') {
			//status = sessionStorage.getItem("TITLE.termination");
			status = "Termination";
		} else {
			status = '-';
		}

		if (info.wl == undefined || info.wl == null || isNaN(info.wl)) {
			wl = "-";
		} else {
			wl = Number(info.wl).toFixed(2);
		}

		if (info.wrnstep1 == undefined || info.wrnstep1 == null || isNaN(info.wrnstep1)) {
			wrnstep1 = "-";
		} else {
			wrnstep1 = Number(info.wrnstep1).toFixed(2);
		}

		if (info.wrnstep2 == undefined || info.wrnstep2 == null || isNaN(info.wrnstep2)) {
			wrnstep2 = "-";
		} else {
			wrnstep2 = Number(info.wrnstep2).toFixed(2);
		}

		if (info.wrnstep3 == undefined || info.wrnstep3 == null || isNaN(info.wrnstep3)) {
			wrnstep3 = "-";
		} else {
			wrnstep3 = Number(info.wrnstep3).toFixed(2);
		}

		wpTableHtml += '<tr id="' + info.wpobscd + '">';
		wpTableHtml += '    <td>' + info.obsnm + '</td>';
		wpTableHtml += '    <td>' + info.ymdhm + '</td>';
		wpTableHtml += '    <td>' + status + '</td>';
		wpTableHtml += '    <td>';
		if (status == "-" || status == undefined || status == null || status == "Termination") {
			wpTableHtml += '	<span class="play" style="display:none;"><img src="/images/play.svg" alt="audio play"></span>';
			wpTableHtml += '	<span class="pause" style="display:none;"><img src="/images/pause.svg" alt="audio pause"></span>';
		} else {
			wpTableHtml += '	<span class="play"><img src="/images/play.svg" alt="audio play"></span>';
			wpTableHtml += '	<span class="pause"><img src="/images/pause.svg" alt="audio pause"></span>';
		}
		wpTableHtml += '    </td>';
		wpTableHtml += '    <td>' + info.wlobsnm + '</td>';
		wpTableHtml += '    <td>' + info.wlymdhm + '</td>';
		wpTableHtml += '    <td>' + wl + '</td>';
		wpTableHtml += '    <td>' + wrnstep1 + '</td>';
		wpTableHtml += '    <td>' + wrnstep2 + '</td>';
		wpTableHtml += '    <td>' + wrnstep3 + '</td>';
		wpTableHtml += '</tr>';
	});

	warningTbody.innerHTML = wpTableHtml;

	audioPlayer();
}

// 음악재생
function audioPlayer() {
	let currentAudioPlayer = null; // 현재 재생 중인 오디오를 추적

	// Play 버튼 이벤트 리스너
	document.querySelectorAll('.play').forEach(playBtn => {
		playBtn.addEventListener('click', function(event) {
			wpSound(this.closest('tr').id).then(filenm => {
				if (filenm) {
					let soundPath = "/sound/" + filenm;

					// 이전에 재생 중인 오디오가 있으면 정지
					if (currentAudioPlayer) {
						currentAudioPlayer.pause();
						currentAudioPlayer.currentTime = 0; // 시간을 처음으로 돌림
					}

					// 새로운 오디오 객체 생성 및 재생
					currentAudioPlayer = new Audio(soundPath);
					currentAudioPlayer.play();
				}
			});
			event.stopPropagation();
		});
	});

	// Pause 버튼 이벤트 리스너
	document.querySelectorAll('.pause').forEach(pauseBtn => {
		pauseBtn.addEventListener('click', function(event) {
			if (currentAudioPlayer) {
				currentAudioPlayer.pause();
			}
			event.stopPropagation();
		});
	});
}

$("#searchBtn").on("click", function() {
	let startDate = Common.createDate("scSDate", "scSHour", "scSMin");
	let endDate = Common.createDate("scEDate", "scEHour", "scEMin");

	Common.checkDateDiff(startDate, endDate, "year").then((res) => {
		if (!res) return;

		let wpStatus = document.getElementById("wpStatus").value;
		warningData(wpStatus);
	});
});

$("#wpStatus").on("change", function() {
	let wpStatus = document.getElementById("wpStatus").value;
	warningData(wpStatus);
});

const wpSound = function(wpobscd) {
	let rfParam = makeMstParam();
	/*let sdt = setDateTime().sdt;
	let edt = setDateTime().edt;*/

	return axios.all([
		axios.post(`/warning/getWpSound/wpobscd/sdt/edt`, new URLSearchParams({ wpobscd: wpobscd, sdt: rfParam.ymdhm.sdt, edt: rfParam.ymdhm.edt }))
	]).then(axios.spread((issResponse) => {
		const issinfo = issResponse.data.resultData;

		if (issinfo != null) {
			let filenm = issinfo.filenm;

			return filenm;
		}
	}));
}

const makeMstParam = function() {
	let scSDate = document.getElementById("scSDate").value;
	let replacescSDate = scSDate.replaceAll("-", "");
	let scSHour = document.getElementById("scSHour").value;
	let scSMin = document.getElementById("scSMin").value;
	let sdt = replacescSDate + scSHour + scSMin;
	let sYmd = replacescSDate;
	let sYmdh = replacescSDate + scSHour;

	let scEDate = document.getElementById("scEDate").value;
	let replacescEDate = scEDate.replaceAll("-", "");
	let scEHour = document.getElementById("scEHour").value;
	let scEMin = document.getElementById("scEMin").value;
	let edt = replacescEDate + scEHour + scEMin;
	let eYmd = replacescEDate;
	let eYmdh = replacescEDate + scEHour;

	// 년월일
	const ymd = { sdt: sYmd, edt: eYmd };
	const ymdh = { sdt: sYmdh, edt: eYmdh };
	const ymdhm = { sdt: sdt, edt: edt };

	return { ymd: ymd, ymdh: ymdh, ymdhm: ymdhm };
}

function setDateTime() {
	// 검색 날짜 가져오기
	const searchDt = Common.getDateTime2Blank(document.getElementById("searchDate").value)
	const searchHr = document.getElementById("searchHour").value
	const searchMin = document.getElementById("searchMin").value
	const searchEdt = searchDt + searchHr + searchMin

	// 검색 날짜 날짜로 변환
	let year = searchEdt.substring(0, 4);
	let month = searchEdt.substring(4, 6) - 1;
	let day = searchEdt.substring(6, 8);
	let hour = searchEdt.substring(8, 10);
	let minute = searchEdt.substring(10, 12);

	const date = new Date(year, month, day, hour, minute);

	//edt 날짜
	let y = date.getFullYear();
	let M = date.getMonth() + 1;
	let d = date.getDate();
	let h = date.getHours();
	let m = date.getMinutes();

	M = M < 10 ? "0" + M : M;
	d = d < 10 ? "0" + d : d;
	h = h < 10 ? "0" + h : h;
	m = m < 10 ? "0" + m : m;

	let edt = y + M + d + h + m;

	//sdt 날짜
	const preDate = new Date(year, month, day, hour, minute);
	preDate.setDate(preDate.getDate() - 7);

	let py = preDate.getFullYear();
	let pM = preDate.getMonth() + 1;
	let pd = preDate.getDate();
	let ph = preDate.getHours();
	let pm = preDate.getMinutes();

	pM = pM < 10 ? "0" + pM : pM;
	pd = pd < 10 ? "0" + pd : pd;
	ph = ph < 10 ? "0" + ph : ph;
	pm = pm < 10 ? "0" + pm : pm;

	let sdt = py.toString() + pM.toString() + pd.toString() + ph.toString() + pm.toString();

	return { sdt: sdt, edt: edt }
}